import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-75754b6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "note-both"
}
const _hoisted_2 = { class: "note-letter" }
const _hoisted_3 = ["width", "height", "viewBox"]
const _hoisted_4 = ["d"]
const _hoisted_5 = ["width", "height", "viewBox"]
const _hoisted_6 = ["d"]

import { computed } from "vue";
import {
  getDisplayNoteName,
  parseNoteComponents,
  type AccidentalDisplayMode,
} from "@/utils/noteUtils";
import { svgPaths } from "@/utils/svgPaths";

interface Props {
  chromaticIndex: number;
  displayMode?: AccidentalDisplayMode;
  keySignature?: string;
  size?: "small" | "medium" | "large";
}


export default /*#__PURE__*/_defineComponent({
  __name: 'NoteLabel',
  props: {
    chromaticIndex: {},
    displayMode: { default: "logical" },
    keySignature: {},
    size: { default: "medium" }
  },
  setup(__props: any) {

const props = __props;

const displayName = computed(() => {
  return getDisplayNoteName(
    props.chromaticIndex,
    props.displayMode,
    props.keySignature
  );
});

const noteComponents = computed(() => {
  return parseNoteComponents(displayName.value);
});

const noteLetter = computed(() => {
  return noteComponents.value.letter;
});

const hasAccidental = computed(() => {
  return noteComponents.value.isSharp || noteComponents.value.isFlat;
});

const isSharp = computed(() => {
  return noteComponents.value.isSharp;
});

const isFlat = computed(() => {
  return noteComponents.value.isFlat;
});

const isBothMode = computed(() => {
  return props.displayMode === "both" && displayName.value.includes("/");
});

// Dynamic sizing for SVG accidental symbols based on component size
const getAccidentalSize = computed(() => () => {
  switch (props.size) {
    case "small":
      return { width: 7, height: 13 }; // ~70% of original
    case "large":
      return { width: 9, height: 17 }; // ~130% of original
    case "medium":
    default:
      return { width: 7, height: 13 }; // Original size
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["note-label", [
      `note-label--${_ctx.size}`,
      {
        'note-label--accidental': hasAccidental.value,
        'note-label--both': isBothMode.value,
      },
    ]])
  }, [
    (isBothMode.value)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(displayName.value), 1))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("span", _hoisted_2, _toDisplayString(noteLetter.value), 1),
          (isSharp.value)
            ? (_openBlock(), _createElementBlock("svg", {
                key: 0,
                class: "note-accidental note-accidental--sharp",
                width: getAccidentalSize.value().width,
                height: getAccidentalSize.value().height,
                viewBox: _unref(svgPaths).sharp.viewBox
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(svgPaths).sharp.paths, (path, index) => {
                  return (_openBlock(), _createElementBlock("path", {
                    key: index,
                    d: path.d,
                    fill: "currentColor"
                  }, null, 8, _hoisted_4))
                }), 128))
              ], 8, _hoisted_3))
            : _createCommentVNode("", true),
          (isFlat.value)
            ? (_openBlock(), _createElementBlock("svg", {
                key: 1,
                class: "note-accidental note-accidental--flat",
                width: getAccidentalSize.value().width,
                height: getAccidentalSize.value().height,
                viewBox: _unref(svgPaths).flat.viewBox
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(svgPaths).flat.paths, (path, index) => {
                  return (_openBlock(), _createElementBlock("path", {
                    key: index,
                    d: path.d,
                    fill: "currentColor"
                  }, null, 8, _hoisted_6))
                }), 128))
              ], 8, _hoisted_5))
            : _createCommentVNode("", true)
        ], 64))
  ], 2))
}
}

})